module.exports = __webpack_public_path__ + "3c11123f30569bf76cf66d279da0b0ef.svg";